import { http } from 'services/http';
import { ORDER_GET_ONE, ORDERS_GET_MANY } from 'api/query-keys.ts';
import type { TOrderRes, UpdateOrderStatusReq } from 'api/swagger';
import { useMutationBase } from 'shared/hooks/use-mutation-base.ts';

export const useUpdateStatus = (orderId: number) => {
  return useMutationBase<TOrderRes, unknown, UpdateOrderStatusReq>({
    mutationFn: async (variables) => {
      const res = await http.patch<TOrderRes>(`/v1/orders/${orderId}/status`, variables);

      return res.data;
    },

    invalidateCallback: ({ id }) => [[ORDER_GET_ONE, id], [ORDERS_GET_MANY]],
  });
};
